import { useEffect, useState } from 'react'
import type { FC } from 'react'
import cn from 'classnames'
import { Dropdown } from 'components/ui'
import type { DropdownItem } from 'components/ui/dropdown'
import { withRouter } from 'next/router'
import { ProductCard } from 'modules/products/containers'
import type { ProductGridProps } from '.'
import s from './product-grid.module.css'

const ORDERS: DropdownItem[] = [
  // { value: 'popular', label: 'Mais vendidos' },
  // { value: 'new', label: 'Novos por aqui' },
  { value: 'asc', label: 'Menor preço' },
  { value: 'desc', label: 'Maior preço' },
]

const ProductGrid: FC<ProductGridProps> = ({ products, className, router, filters }) => {
  const [order, setOrder] = useState<DropdownItem['value']>(null as unknown as DropdownItem['value'])

  useEffect(() => {
    const { query } = router
    setOrder(query?.order || null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onChangeOrder(value: DropdownItem['value']) {
    setOrder(value)
    router.push({ ...router, query: { ...router.query, sort: value } })
  }

  return (
    <div className={cn(s.root, className)}>
      <div className={s.header}>
        <div className={s.densities}>{filters}</div>
        <div className={s.order}>
          <Dropdown pre="" items={ORDERS} placeholder="Ordenar por" onSelect={onChangeOrder} selected={order} />
        </div>
      </div>
      <div className={s.productListGrid}>
        {products.map((product) => (
          <ProductCard key={`product-grid-${product.id}`} product={product} />
        ))}
      </div>
    </div>
  )
}

export default withRouter(ProductGrid)
